<template>
    <div>
        <nav class="row">
            <div class="col-sm-4 col-lg text-center">
                <div>
                    <p class="text-uppercase text-muted heading">Filter Set</p>
                    <p class="title" data-cy="filterSet">{{ testResults.testType }}</p>
                </div>
            </div>
            <div class="col-sm-4 col-lg text-center">
                <div>
                    <p class="text-uppercase text-muted heading">Target Type</p>
                    <p class="title" data-cy="targetType">{{ testResults.testPattern }}</p>
                </div>
            </div>
            <div class="col-sm-4 col-lg text-center">
                <div>
                    <p class="text-uppercase text-muted heading"># Filters Considered</p>
                    <p class="title" data-cy="numFiltersConsidered">{{ this.numFilters }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg text-center">
                <div>
                    <p class="text-uppercase text-muted heading"># Playoff Rounds</p>
                    <p class="title" data-cy="numPlayoffRounds">{{ testResults.playoffRounds.length }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg text-center">
                <div>
                    <p class="text-uppercase text-muted heading">Narrowed Down To</p>
                    <p class="title" data-cy="numNarrowedDownTo">{{ testResults.preferred.length }}</p>
                </div>
            </div>
        </nav>
        <div class="row justify-content-md-center mb-4" v-if="testResults.preferred && testResults.preferred.length < 4">
            <div v-for="item in testResults.preferred" :key="item.sortOrder" class="col-md-6 col-lg-4 mt-2 mt-sm-0">
                <div class="card mx-auto">
                    <div class="card-header">
                        <h4 class="text-uppercase">Preferred Filter</h4>
                    </div>
                    <div class="row">
                        <div class="col-4 text-center p-2" style="min-width: 6rem;">
                              <span :style="`color: rgb(${item.red},${item.green},${item.blue})`">
                                <font-awesome-icon icon="square" size="5x"/>
                              </span>
                        </div>
                        <div class="col text-left p-2">
                            <h4 class="text-primary" data-cy="preferredFilterName">{{ item.name ? item.name : 'Filter' }}</h4>
                            <div class="text-muted">RGB({{ item.red }}, {{ item.green }}, {{ item.blue }})</div>
                        </div>
                    </div>
                    <div class="pb-2">
                        <router-link class="btn btn-outline-info text-uppercase"
                                     :to="{ name: 'PreferredFilterPreview', params: { testId: routeTestId, color: rgbToHexFromFilter(item) }}">
                            <i class="fas fa-expand-arrows-alt mr-1"/> <span>Preview</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-centered section" v-if="testResults.preferred && testResults.preferred.length > 3">
            <div class="alert alert-warning">
                <font-awesome-icon icon="exclamation-triangle" style="font-size:1.4rem;"/>
                Unfortunately we could not narrow down to 3 filters. The best we could do was {{
                testResults.preferred.length }} filters. Please consider re-running the test with a different filter
                set.
            </div>
        </div>
        <div class="columns is-centered section" v-if="!testResults.preferred || testResults.preferred.length === 0">
            <div class="alert alert-warning">
                <font-awesome-icon icon="exclamation-triangle" style="font-size:1.4rem;"/>
                Sorry but a recommendation can not be made because zero positive ratings were provided!
            </div>
        </div>

        <div class="row filterStats border m-1 p-2 rounded bg-light">
            <div class="col-md">
                <rating-stat :count="stats.negativeTwo" rating="-2" icon="thumbs-down"/>
            </div>
            <div class="col-md">
                <rating-stat :count="stats.negativeOne" rating="-1" icon="frown"/>
            </div>
            <div class="col-md">
                <rating-stat :count="stats.zero" rating="0" icon="meh"/>
            </div>
            <div class="col-md">
                <rating-stat :count="stats.positiveOne" rating="1" icon="smile"/>
            </div>
            <div class="col-md">
                <rating-stat :count="stats.positiveTwo" rating="2" icon="thumbs-up"/>
            </div>
        </div>

    </div>
</template>

<script>
    import WrittenNumber from 'written-number';
    import RatingStat from "./RatingStat";

    export default {
        name: 'ResultsOverview',
        components: {RatingStat},
        props: ['testResults'],
        data() {
            return {
                numFilters: 0,
                stats: {},
            };
        },
        mounted() {
            const filtersWithoutBaseline = this.testResults.filters.filter(item => item.baseline === true);
            this.numFilters = filtersWithoutBaseline.length + 1;

            this.stats.negativeTwo = WrittenNumber(this.testResults.filters.filter(item => item.rating === -2).length);
            this.stats.negativeOne = WrittenNumber(this.testResults.filters.filter(item => item.rating === -1).length);
            this.stats.zero = WrittenNumber(this.testResults.filters.filter(item => item.rating === 0).length);
            this.stats.positiveOne = WrittenNumber(this.testResults.filters.filter(item => item.rating === 1).length);
            this.stats.positiveTwo = WrittenNumber(this.testResults.filters.filter(item => item.rating === 2).length);
        },
        computed: {
            routeTestId() {
                return this.$route.params.testId;
            },
        },
        methods: {
            rgbToHexFromFilter(filter) {
                return this.rgbToHex(filter.red, filter.green, filter.blue);
            },
            rgbToHex(r, g, b) {
                return `#${this.componentToHex(r)}${this.componentToHex(g)}${this.componentToHex(b)}`;
            },
            componentToHex(c) {
                const hex = c.toString(16);
                return hex.length === 1 ? `0${hex}` : hex;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .heading {
        font-size: 0.8rem;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }

    .title {
        font-size: 2.3rem;
        font-weight: 700;
        padding-top: 0px;
        margin-top: 0px;
    }

    .preferredTitle {
        font-size: 1.5rem;
    }

    @media print {
        .no-print, .no-print * {
            display: none !important;
        }
    }
</style>
